import DatePicker from '@rio-cloud/rio-uikit/lib/es/DatePicker';
import moment, { Moment } from 'moment';
import classNames from 'classnames';
import {
  CustomFormattedMessage,
  getMomentLocale,
  TranslationsKeys,
} from '../i18n/i18n';

type DateFilterPickerProps = {
  labelId: TranslationsKeys;
  value: Moment;
  onChange: (millis: number) => void;
  isDateBlocked?: (currentDate: Moment) => boolean;
  blockFutureDates?: boolean;
  errorMessageId?: (value: Moment) => TranslationsKeys | false;
  'data-testid'?: string;
};

export const DateFilterPicker = ({
  labelId,
  value,
  onChange,
  isDateBlocked,
  blockFutureDates = true,
  errorMessageId,
  'data-testid': testId,
}: DateFilterPickerProps) => {
  const handleChange = (val: Moment | string, valid: boolean) => {
    if (!valid) return;
    const convertedVal =
      typeof val === 'string' ? parseFloat(val) : val.valueOf();
    onChange(convertedVal);
  };

  const errorId = errorMessageId?.(value);

  return (
    <div data-testid={testId}>
      <label>
        <CustomFormattedMessage id={labelId} />
      </label>
      <div
        className={classNames('DatePicker', {
          'form-group has-feedback has-error': errorId,
        })}
      >
        <DatePicker
          closeOnSelect
          timeFormat={false}
          value={value}
          minWidth={140}
          onChange={handleChange}
          isValidDate={(d) =>
            (!blockFutureDates || d.isSameOrBefore(moment(), 'day')) &&
            (!isDateBlocked || !isDateBlocked(d))
          }
          locale={getMomentLocale()}
        />
        {errorId && (
          <>
            <span className="form-control-feedback rioglyph rioglyph-error-sign" />
            <span className="help-block">
              <span>
                <CustomFormattedMessage id={errorId} />
              </span>
            </span>
          </>
        )}
      </div>
    </div>
  );
};
